import { ItemsManagerProvider } from '../../items-manager';
import { SyncItemResponse } from '../../../../bayadic-shared-models/item/sync-item-response';
import { SyncItemRequest } from '../../../../bayadic-shared-models/item/sync-item-request';
import { LoggerService } from '../../../../app/services/logger.service';
import { ACTIONS } from '../../../../bayadic-shared-models/enums/Enums';
export class ItemsSynchronizer {
    public itemsMgr: ItemsManagerProvider;
    public static syncItems = ACTIONS.syncItems;
    public syncing: boolean = false;
    constructor(itemsMgr: ItemsManagerProvider,
        public logger: LoggerService
    ) {
        this.itemsMgr = itemsMgr;
    }

    async sync() {
        if (this.syncing) return false;
        this.syncing = true;
        const localItemIDs: Array<string> = this.itemsMgr.items.map(item => item.itemID);
        
        const result = await this.itemsMgr.socketManager
        .asyncQuery<SyncItemResponse, SyncItemRequest>(ACTIONS.syncItems,{ itemIDs: localItemIDs }, true);
        this.logger.debug("syncing items", result);
        await this.itemsMgr.createItems(result.created);


        for (let itemID of result.deleted) {
            let item = this.itemsMgr.find(itemID);
            this.itemsMgr.deleteItemLocally(item);
        }
    }


}